export enum SystemLanguage {
  zhCN = "zh-CN",
  zhHK = 'zh-HK',
  enUS = "en-US",
}